import axios from 'axios';

export function getApiValidationCall(lang: string, callbackSuccess: () => void, callbackError: (error: string) => void) {
  return (password: string) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    axios.post<{ errors: { field: string; message: string }[] }>(
      `${process.env.REACT_APP_ACCOUNT_PUBLIC_API}/account/password`,
      {
        password,
      },
      {
        headers: { 'Accept-Language': lang },
        validateStatus: () => true,
      },
    ).then(
      (response) => {
        if (response.status === 400) {
          callbackError(response?.data?.errors[0]?.message);
        } else {
          callbackSuccess();
        }
      },
    );
  };
}
